import './LoadingState.css';
export var dataTableHeaderHeight = 'var(--_14flfjk0-3-8-0)';
export var dataTableScrollOffset = 'var(--_14flfjk1-3-8-0)';
export var loadingState = '_14flfjk2-3-8-0';